import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const Peru = () => {
    return <SharedDocumentsComponent permissionId="47" path="Peru" />
}